<div class="inscripcion-bg" *ngIf="phase === 'inscripcion'">
<div class="inscripcion-os-container">

    <!-- ===== HEADER ESTILO AUDITORIA ===== -->
    <div class="inscripcion-header">
      <div class="inscripcion-header__accent"></div>
      <div class="container inscripcion-header__inner">
        <span class="material-icons inscripcion-header__icon">assignment_ind</span>
        <div>
          <h1 class="inscripcion-header__title">Inscripción · <span>O.S.O.E.T.S.Y.L.R.A.</span></h1>
          <p class="inscripcion-header__subtitle">Formulario de afiliación — Código O.S. 1-2740-6</p>
        </div>
      </div>
    </div>

    <div class="inscripcion-form-container">
      <form [formGroup]="inscripcionForm" (ngSubmit)="onSubmit()">

        <!-- ===== STEP BAR ===== -->
        <div class="step-bar">
          <ng-container *ngFor="let step of steps; let i = index">
            <div class="step"
                 [class.active]="currentStep === i + 1"
                 [class.completed]="maxStepReached > i + 1"
                 [class.error-step]="stepErrors[i]"
                 (click)="irAPaso(i + 1)">
              <div class="step-circle">
              <i *ngIf="maxStepReached > i + 1 && !stepErrors[i]" class="fas fa-check"></i>
                <span *ngIf="maxStepReached <= i + 1 || stepErrors[i]">{{ i + 1 }}</span>
              </div>
              <span class="step-label">{{ step }}</span>
            </div>
          </ng-container>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 1: DATOS DEL TITULAR -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 1" class="step-content">
          <div class="step-title">Datos del titular</div>

          <div formGroupName="datosDelTitular">

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Apellido</mat-label>
                <input matInput type="text" formControlName="apellido">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.apellido')?.hasError('required') && inscripcionForm.get('datosDelTitular.apellido')?.touched">
                  El apellido es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.apellido')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="nombre">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nombre')?.hasError('required') && inscripcionForm.get('datosDelTitular.nombre')?.touched">
                  El nombre es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nombre')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Tipo de Documento</mat-label>
                <mat-select formControlName="tipoDocumento">
                  <mat-option [value]="TipoDocumento.DNI">DNI</mat-option>
                  <mat-option [value]="TipoDocumento.CI">CI</mat-option>
                  <mat-option [value]="TipoDocumento.LE">LE</mat-option>
                  <mat-option [value]="TipoDocumento.LC">LC</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.tipoDocumento')?.hasError('required') && inscripcionForm.get('datosDelTitular.tipoDocumento')?.touched">
                  El tipo de documento es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Número de Documento</mat-label>
                <input matInput type="text" formControlName="numeroDocumento">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.numeroDocumento')?.hasError('required') && inscripcionForm.get('datosDelTitular.numeroDocumento')?.touched">
                  El número de documento es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.numeroDocumento')?.hasError('pattern')">
                  Solo números, máximo 10 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>CUIL</mat-label>
                <input matInput placeholder="00-00000000-0" type="text" formControlName="cuil">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.cuil')?.hasError('required') && inscripcionForm.get('datosDelTitular.cuil')?.touched">
                  El CUIL es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.cuil')?.hasError('pattern')">
                  Solo números, máximo 12 dígitos
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Fecha de Nacimiento</mat-label>
                <input matInput [matDatepicker]="pickerTitular" formControlName="fechaNacimiento" appDirectivaFechas readonly (click)="pickerTitular.open()">
                <mat-datepicker-toggle matSuffix [for]="pickerTitular"></mat-datepicker-toggle>
                <mat-datepicker #pickerTitular></mat-datepicker>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.fechaNacimiento')?.hasError('required') && inscripcionForm.get('datosDelTitular.fechaNacimiento')?.touched">
                  La fecha de nacimiento es requerida
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Sexo</mat-label>
                <mat-select formControlName="sexo">
                  <mat-option [value]="Sexo.Masculino">Masculino</mat-option>
                  <mat-option [value]="Sexo.Femenino">Femenino</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.sexo')?.hasError('required') && inscripcionForm.get('datosDelTitular.sexo')?.touched">
                  El sexo es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nacionalidad</mat-label>
                <input matInput type="text" formControlName="nacionalidad">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nacionalidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.nacionalidad')?.touched">
                  La nacionalidad es requerida
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.nacionalidad')?.hasError('pattern')">
                  Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Incapacitado</mat-label>
                <mat-select formControlName="incapacitado">
                  <mat-option [value]="true">Sí</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.incapacitado')?.hasError('required') && inscripcionForm.get('datosDelTitular.incapacitado')?.touched">
                  Este campo es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Estado Civil</mat-label>
                <mat-select formControlName="estadoCivil">
                  <mat-option [value]="EstadoCivil.Soltero">Soltero</mat-option>
                  <mat-option [value]="EstadoCivil.Casado">Casado</mat-option>
                  <mat-option [value]="EstadoCivil.Divorciado">Divorciado</mat-option>
                  <mat-option [value]="EstadoCivil.Viudo">Viudo</mat-option>
                </mat-select>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.estadoCivil')?.hasError('required') && inscripcionForm.get('datosDelTitular.estadoCivil')?.touched">
                  El estado civil es requerido
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Domicilio del Titular -->
            <div class="step-subtitle">Domicilio</div>
            <div formGroupName="domicilio">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Dirección</mat-label>
                  <input matInput type="text" formControlName="direccion">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.direccion')?.touched">
                    La dirección es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput type="text" formControlName="numero">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.numero')?.touched">
                    El número es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('pattern')">
                    Solo números y letras. Máximo 10 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Piso</mat-label>
                  <input matInput type="text" formControlName="piso">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.piso')?.hasError('pattern')">
                    Solo números, letras y guión. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Departamento</mat-label>
                  <input matInput type="text" formControlName="departamento">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.departamento')?.hasError('pattern')">
                    Solo números y letras. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Localidad</mat-label>
                  <input matInput type="text" formControlName="localidad">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.localidad')?.touched">
                    La localidad es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Provincia</mat-label>
                  <input matInput type="text" formControlName="provincia">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.provincia')?.touched">
                    La provincia es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Código Postal</mat-label>
                  <input matInput type="text" formControlName="codigoPostal">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.touched">
                    El código postal es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('pattern')">
                    Solo números y letras. Máximo 8 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 2: CONTACTO Y DOMICILIO -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 2" class="step-content">
          <div class="step-title">Contacto y domicilio</div>

          <div formGroupName="datosDelTitular">
            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Teléfono</mat-label>
                <input matInput type="text" formControlName="telefono">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.telefono')?.hasError('required') && inscripcionForm.get('datosDelTitular.telefono')?.touched">
                  El teléfono es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.telefono')?.hasError('pattern')">
                  Solo números, máximo 15 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Celular</mat-label>
                <input matInput type="text" formControlName="celular">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.celular')?.hasError('required') && inscripcionForm.get('datosDelTitular.celular')?.touched">
                  El celular es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.celular')?.hasError('pattern')">
                  Solo números, máximo 15 dígitos
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email">
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.email')?.hasError('required') && inscripcionForm.get('datosDelTitular.email')?.touched">
                  El email es requerido
                </mat-error>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.email')?.hasError('pattern')">
                  Formato de email inválido. Debe contener @ y un dominio válido.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="step-subtitle">Domicilio</div>
            <div formGroupName="domicilio">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Dirección</mat-label>
                  <input matInput type="text" formControlName="direccion">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.direccion')?.touched">
                    La dirección es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.direccion')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput type="text" formControlName="numero">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.numero')?.touched">
                    El número es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.numero')?.hasError('pattern')">
                    Solo números y letras. Máximo 10 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Piso</mat-label>
                  <input matInput type="text" formControlName="piso">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.piso')?.hasError('pattern')">
                    Solo números, letras y guión. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Departamento</mat-label>
                  <input matInput type="text" formControlName="departamento">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.departamento')?.hasError('pattern')">
                    Solo números y letras. Máximo 5 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Localidad</mat-label>
                  <input matInput type="text" formControlName="localidad">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.localidad')?.touched">
                    La localidad es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.localidad')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Provincia</mat-label>
                  <input matInput type="text" formControlName="provincia">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.provincia')?.touched">
                    La provincia es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.provincia')?.hasError('pattern')">
                    Solo letras, apóstrofes y espacios. Máximo 50 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Código Postal</mat-label>
                  <input matInput type="text" formControlName="codigoPostal">
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('required') && inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.touched">
                    El código postal es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDelTitular.domicilio.codigoPostal')?.hasError('pattern')">
                    Solo números y letras. Máximo 8 caracteres.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 3: DATOS LABORALES -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 3" class="step-content">
          <div class="step-title">Régimen laboral</div>

          <div formGroupName="datosDelTitular">
            <div class="regimenes-laborales">
              <mat-radio-group formControlName="regimenLaboral">
                <div class="opcion-regimen">
                  <mat-radio-button [value]="RegimenLaboral.General">Relación de Dependencia</mat-radio-button>
                </div>
                <div class="opcion-regimen">
                  <mat-radio-button [value]="RegimenLaboral.Monotributo">Monotributo</mat-radio-button>
                </div>
                <div class="opcion-regimen">
                  <mat-radio-button [value]="RegimenLaboral.ServicioDomestico">Servicio Doméstico</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>

            <div class="regimen-error" *ngIf="inscripcionForm.get('datosDelTitular.regimenLaboral')?.hasError('required') && inscripcionForm.get('datosDelTitular.regimenLaboral')?.touched">
              Debe seleccionar un régimen laboral para continuar.
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline">
                <mat-label>Fecha de ingreso a la empresa</mat-label>
                <input matInput [matDatepicker]="pickerIngreso" formControlName="fechaIngresoEmpresa" appDirectivaFechas readonly (click)="pickerIngreso.open()">
                <mat-datepicker-toggle matSuffix [for]="pickerIngreso"></mat-datepicker-toggle>
                <mat-datepicker #pickerIngreso></mat-datepicker>
                <mat-error *ngIf="inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.hasError('required') && inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.touched">
                  La fecha de ingreso es requerida
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Datos de la Empresa (oculto para Monotributo) -->
          <div *ngIf="showEmpresaSection" class="step-subsection">
            <div class="step-subtitle">Datos de la empresa o empleador</div>
            <div formGroupName="datosDeLaEmpresa">
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Razón social</mat-label>
                  <input matInput type="text" formControlName="razonSocial">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.touched">
                    La razón social es requerida
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas, & y guión. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>C.U.I.T</mat-label>
                  <input matInput type="text" formControlName="cuit">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.cuit')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.cuit')?.touched">
                    El CUIT es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.cuit')?.hasError('pattern')">
                    Solo números, máximo 11 dígitos
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Domicilio</mat-label>
                  <input matInput type="text" formControlName="domicilio">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.domicilio')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.domicilio')?.touched">
                    El domicilio es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.domicilio')?.hasError('pattern')">
                    Solo letras, números, espacios, puntos, comas y guiones. Máximo 100 caracteres.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Teléfono</mat-label>
                  <input matInput type="text" formControlName="telefono">
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.telefono')?.hasError('required') && inscripcionForm.get('datosDeLaEmpresa.telefono')?.touched">
                    El teléfono es requerido
                  </mat-error>
                  <mat-error *ngIf="inscripcionForm.get('datosDeLaEmpresa.telefono')?.hasError('pattern')">
                    Solo números, máximo 15 dígitos
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 4: GRUPO FAMILIAR -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 4" class="step-content">
          <div class="step-title">Grupo Familiar</div>

          <div formArrayName="familiares">
            <div class="familiares-list">
              <div class="familiar-card" *ngFor="let familiar of familiaresFormArray.controls; let i = index">
                <div class="familiar-card__info">
                  <span class="familiar-card__icon material-icons">person</span>
                  <div>
                    <strong>{{ familiar.get('nombre')?.value }} {{ familiar.get('apellido')?.value }}</strong>
                    <small>{{ familiar.get('parentesco')?.value === Parentesco.Hijo ? 'Hijo/a' : familiar.get('parentesco')?.value === Parentesco.Esposo ? 'Esposo/a' : 'Concubino/a' }}</small>
                  </div>
                </div>
                <div class="familiar-card__actions">
                  <button type="button" mat-icon-button color="primary" (click)="editFamiliar(i)" matTooltip="Editar familiar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" mat-icon-button color="warn" (click)="removeFamiliar(i)" matTooltip="Eliminar familiar">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="familiares-empty" *ngIf="familiaresFormArray.length === 0">
              <span class="material-icons" style="font-size:40px;color:var(--optionalColor);">group</span>
              <p>No hay familiares cargados. Puede agregarlos o continuar sin grupo familiar.</p>
            </div>
          </div>

          <div class="add-familiar-button">
            <button type="button" mat-stroked-button color="primary" (click)="addFamiliar()">
              <mat-icon>person_add</mat-icon> Agregar Familiar
            </button>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 5: DOCUMENTACIÓN DNI / CODEM -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 5" class="step-content">
          <div class="step-title">Documentación DNI y CODEM</div>
          <p class="step-desc">Seleccione un archivo para cada documento requerido. Formatos: PDF, JPG, PNG (máx. 50 MB).</p>

          <div class="files-requirement-info">
            <mat-icon>info</mat-icon>
            <span>
              <strong>Importante:</strong> Se requiere el frente y dorso del DNI del titular más el CODEM.
              <a href="https://www.anses.gob.ar/consultas/obra-social-codem" target="_blank" class="link-doc">¿Qué es el CODEM?</a>
            </span>
          </div>

          <div class="file-slots-grid">
            <div *ngFor="let slot of dniFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[4] && !slot.file)">
              <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
              </div>
              <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                <img [src]="slot.preview.safeUrl" class="file-slot__img">
              </div>
              <div class="file-slot__info">
                <span class="file-slot__label">{{ slot.label }}</span>
                <span class="file-slot__desc">{{ slot.descripcion }}</span>
                <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
              </div>
              <input type="file" #dniInput hidden (change)="onSlotFileSelected(i, 'dni', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
              <div class="file-slot__actions">
                <button type="button" class="btn-slot" (click)="dniInput.click()">
                  {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                </button>
                <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'dni')" matTooltip="Eliminar">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 6: DOCUMENTACIÓN DE ACTIVIDAD -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 6" class="step-content">
          <div class="step-title">Documentación adicional</div>
          <p class="step-desc">Documentos requeridos para <strong>{{ getRegimenLaboralNombre() }}</strong>.</p>

          <ng-container *ngIf="actividadFileSlots.length > 0; else noActividadDocs">
            <div class="file-slots-grid">
              <div *ngFor="let slot of actividadFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[5] && !slot.file)">
                <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                  <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                  <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
                </div>
                <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                  <img [src]="slot.preview.safeUrl" class="file-slot__img">
                </div>
                <div class="file-slot__info">
                  <span class="file-slot__label">{{ slot.label }}</span>
                  <span class="file-slot__desc">{{ slot.descripcion }}</span>
                  <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                  <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
                </div>
                <input type="file" #actInput hidden (change)="onSlotFileSelected(i, 'actividad', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
                <div class="file-slot__actions">
                  <button type="button" class="btn-slot" (click)="actInput.click()">
                    {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                  </button>
                  <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'actividad')" matTooltip="Eliminar">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noActividadDocs>
            <div class="no-docs-msg">
              <span class="material-icons">check_circle</span>
              <p>No se requieren documentos adicionales para este régimen.</p>
            </div>
          </ng-template>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 7: DOCUMENTACIÓN FAMILIARES -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 7" class="step-content">
          <div class="step-title">Documentación del Grupo Familiar</div>
          <p class="step-desc">Certificados, RUB, CUD y otros documentos requeridos según el grupo familiar.</p>

          <ng-container *ngIf="familiaresFileSlots.length > 0; else noFamiliaresDocs">
            <div class="file-slots-grid">
              <div *ngFor="let slot of familiaresFileSlots; let i = index" class="file-slot" [class.filled]="slot.file" [class.error-slot]="slot.error || (stepErrors[6] && !slot.file)">
                <div class="file-slot__icon" *ngIf="!slot.preview?.isImage">
                  <mat-icon *ngIf="slot.file">check_circle</mat-icon>
                  <mat-icon *ngIf="!slot.file">upload_file</mat-icon>
                </div>
                <div class="file-slot__thumb" *ngIf="slot.preview?.isImage" (click)="openImageModal(slot.preview.url)">
                  <img [src]="slot.preview.safeUrl" class="file-slot__img">
                </div>
                <div class="file-slot__info">
                  <span class="file-slot__label">{{ slot.label }}</span>
                  <span class="file-slot__desc">{{ slot.descripcion }}</span>
                  <span class="file-slot__filename" *ngIf="slot.file">{{ slot.file.name }}</span>
                  <span class="file-slot__error" *ngIf="slot.error">{{ slot.error }}</span>
                </div>
                <input type="file" #famInput hidden (change)="onSlotFileSelected(i, 'familiares', $event)" accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif">
                <div class="file-slot__actions">
                  <button type="button" class="btn-slot" (click)="famInput.click()">
                    {{ slot.file ? 'Cambiar' : 'Seleccionar' }}
                  </button>
                  <button type="button" *ngIf="slot.file" class="btn-slot-remove" (click)="removeSlotFile(i, 'familiares')" matTooltip="Eliminar">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #noFamiliaresDocs>
            <div class="no-docs-msg">
              <span class="material-icons">check_circle</span>
              <p>No hay documentos requeridos para el grupo familiar cargado.</p>
            </div>
          </ng-template>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="button" class="btn-next" (click)="nextStep()">Siguiente</button>
          </div>
        </div>

        <!-- ================================================================ -->
        <!-- PASO 8: REVISIÓN Y ENVÍO -->
        <!-- ================================================================ -->
        <div *ngIf="currentStep === 8" class="step-content">
          <div class="step-title">Revisión y envío</div>
          <p class="step-desc">Verifique los datos antes de enviar la inscripción.</p>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">person</span> Datos del titular</h3>
            <div class="review-row"><span class="k">Nombre</span><span class="v">{{ inscripcionForm.get('datosDelTitular.nombre')?.value }} {{ inscripcionForm.get('datosDelTitular.apellido')?.value }}</span></div>
            <div class="review-row"><span class="k">Documento</span><span class="v">{{ inscripcionForm.get('datosDelTitular.tipoDocumento')?.value === 0 ? 'DNI' : 'Otro' }} {{ inscripcionForm.get('datosDelTitular.numeroDocumento')?.value }}</span></div>
            <div class="review-row"><span class="k">CUIL</span><span class="v">{{ inscripcionForm.get('datosDelTitular.cuil')?.value }}</span></div>
            <div class="review-row"><span class="k">Email</span><span class="v">{{ inscripcionForm.get('datosDelTitular.email')?.value }}</span></div>
            <div class="review-row"><span class="k">Teléfono</span><span class="v">{{ inscripcionForm.get('datosDelTitular.telefono')?.value }} / {{ inscripcionForm.get('datosDelTitular.celular')?.value }}</span></div>
            <div class="review-row"><span class="k">Domicilio</span><span class="v">{{ inscripcionForm.get('datosDelTitular.domicilio.direccion')?.value }} {{ inscripcionForm.get('datosDelTitular.domicilio.numero')?.value }}, {{ inscripcionForm.get('datosDelTitular.domicilio.localidad')?.value }}, {{ inscripcionForm.get('datosDelTitular.domicilio.provincia')?.value }}</span></div>
          </div>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">work</span> Datos laborales</h3>
            <div class="review-row"><span class="k">Régimen</span><span class="v">{{ getRegimenLaboralNombre() }}</span></div>
            <div class="review-row"><span class="k">Fecha ingreso</span><span class="v">{{ inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.value | date:'dd/MM/yyyy' }}</span></div>
            <ng-container *ngIf="showEmpresaSection">
              <div class="review-row"><span class="k">Empresa</span><span class="v">{{ inscripcionForm.get('datosDeLaEmpresa.razonSocial')?.value }}</span></div>
              <div class="review-row"><span class="k">CUIT Empresa</span><span class="v">{{ inscripcionForm.get('datosDeLaEmpresa.cuit')?.value }}</span></div>
            </ng-container>
          </div>

          <div class="review-section" *ngIf="familiaresFormArray.length > 0">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">group</span> Grupo familiar</h3>
            <div class="review-row" *ngFor="let f of familiaresFormArray.controls; let i = index">
              <span class="k">{{ i + 1 }}</span>
              <span class="v">{{ f.get('nombre')?.value }} {{ f.get('apellido')?.value }} ({{ f.get('parentesco')?.value === Parentesco.Hijo ? 'Hijo/a' : f.get('parentesco')?.value === Parentesco.Esposo ? 'Esposo/a' : 'Concubino/a' }})</span>
            </div>
          </div>

          <div class="review-section">
            <h3><span class="material-icons" style="vertical-align:middle;font-size:20px;">description</span> Documentos</h3>
            <div class="review-row"><span class="k">DNI/CODEM</span><span class="v">{{ countFilledSlots(dniFileSlots) }} archivos</span></div>
            <div class="review-row" *ngIf="actividadFileSlots.length > 0"><span class="k">Docs {{ getRegimenLaboralNombre() }}</span><span class="v">{{ selectedActividadFiles.length }} archivos</span></div>
            <div class="review-row" *ngIf="familiaresFileSlots.length > 0"><span class="k">Docs familiares</span><span class="v">{{ selectedFamiliaresFiles.length }} archivos</span></div>
          </div>

          <div class="dev-simular-error" *ngIf="modoAdmin">
            <label>
              <input type="checkbox" [checked]="simularErrorSubidaAdmin" (change)="toggleSimularErrorSubida()">
              <span>DEV: simular error de subida (para probar la re-subida de archivos)</span>
            </label>
          </div>

          <div class="step-actions">
            <button type="button" class="btn-prev" (click)="prevStep()">Anterior</button>
            <button type="submit" class="btn-next" [disabled]="flagRegistrando">Enviar inscripción</button>
          </div>
        </div>

      </form>

      <div class="contact-info">
        <small>
          <a href="https://maps.app.goo.gl/LyBuWxd1pVH1mDHN9" target="_blank" rel="noopener">Culpina 25/31</a> • C1406ENA • Ciudad Autónoma de Buenos Aires • República Argentina
          <br>
          Tel/Fax: 4612-2000 Líneas Rotativas • <a href="https://www.osoetsylra.org" target="_blank" rel="noopener">www.osoetsylra.org</a>
        </small>
      </div>
    </div>
  </div>

  <!-- ===== MODAL FAMILIAR ===== -->
  <div *ngIf="showFamiliarModal" class="familiar-modal-overlay">
    <div class="familiar-modal-content" (click)="$event.stopPropagation()">
      <h3>{{ editingFamiliarIndex === null ? 'Agregar Familiar' : 'Editar Familiar' }}</h3>
      <form [formGroup]="familiarForm" class="familiar-form-content">
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombre" id="familiar-nombre">
            <mat-error *ngIf="familiarForm.get('nombre')?.hasError('required')">El nombre es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('nombre')?.hasError('pattern')">Solo letras, apóstrofes y espacios. Máximo 50 caracteres.</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Apellido</mat-label>
            <input matInput formControlName="apellido" id="familiar-apellido">
            <mat-error *ngIf="familiarForm.get('apellido')?.hasError('required')">El apellido es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('apellido')?.hasError('pattern')">Solo letras, apóstrofes y espacios. Máximo 50 caracteres.</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>DNI</mat-label>
            <input matInput formControlName="numeroDocumento" id="familiar-numeroDocumento">
            <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('required')">El número de documento es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('numeroDocumento')?.hasError('pattern')">Solo números, máximo 10 dígitos</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Parentesco</mat-label>
            <mat-select formControlName="parentesco" id="familiar-parentesco">
              <mat-option [value]="Parentesco.Esposo">Esposo/a</mat-option>
              <mat-option [value]="Parentesco.Concubino">Concubino/a</mat-option>
              <mat-option [value]="Parentesco.Hijo">Hijo/a</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('parentesco')?.hasError('required')">El parentesco es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Nacionalidad</mat-label>
            <mat-select formControlName="nacionalidad" id="familiar-nacionalidad">
              <mat-option [value]="Nacionalidad.Argentino">Argentino/a</mat-option>
              <mat-option [value]="Nacionalidad.Extranjero">Extranjero/a</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('nacionalidad')?.hasError('required')">La nacionalidad es requerida</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Fecha de Nacimiento</mat-label>
            <input matInput [matDatepicker]="familiarFechaNacimientoPicker" formControlName="fechaNacimiento" id="familiar-fechaNacimiento" appDirectivaFechas readonly (click)="familiarFechaNacimientoPicker.open()">
            <mat-datepicker-toggle matSuffix [for]="familiarFechaNacimientoPicker"></mat-datepicker-toggle>
            <mat-datepicker #familiarFechaNacimientoPicker></mat-datepicker>
            <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('required')">La fecha de nacimiento es requerida</mat-error>
            <mat-error *ngIf="familiarForm.get('fechaNacimiento')?.hasError('hijoMayorQueTitular')">La fecha de nacimiento del hijo no puede ser anterior o igual a la del titular.</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding">
          <mat-form-field appearance="outline">
            <mat-label>Incapacidad</mat-label>
            <mat-select formControlName="incapacidad" id="familiar-incapacidad">
              <mat-option [value]="true">Sí</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('incapacidad')?.hasError('required')">Este campo es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Sexo</mat-label>
            <mat-select formControlName="sexo" id="familiar-sexo">
              <mat-option [value]="Sexo.Masculino">Masculino</mat-option>
              <mat-option [value]="Sexo.Femenino">Femenino</mat-option>
            </mat-select>
            <mat-error *ngIf="familiarForm.get('sexo')?.hasError('required')">El sexo es requerido</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CUIL</mat-label>
            <input matInput formControlName="cuil" id="familiar-cuil">
            <mat-error *ngIf="familiarForm.get('cuil')?.hasError('required')">El CUIL es requerido</mat-error>
            <mat-error *ngIf="familiarForm.get('cuil')?.hasError('pattern')">Solo números, máximo 11 dígitos</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row no-padding" *ngIf="esMayorDeEdad()">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" id="familiar-email">
            <mat-error *ngIf="familiarForm.get('email')?.hasError('pattern')">Formato de email inválido.</mat-error>
          </mat-form-field>
        </div>
        <div class="modal-actions-fixed">
          <button type="button" mat-button (click)="closeFamiliarModal()">Cancelar</button>
          <button type="button" mat-raised-button color="primary" (click)="saveFamiliar()">Guardar</button>
        </div>
      </form>
    </div>
  </div>

  <!-- ===== MODAL IMAGEN ===== -->
  <div *ngIf="selectedImageForModal" class="image-modal-overlay" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeImageModal()">
        <mat-icon>close</mat-icon>
      </button>
      <img [src]="sanitizeUrl(selectedImageForModal)" alt="Vista previa ampliada" class="modal-image">
    </div>
  </div>

  <!-- ===== MODAL RECOMENDACIÓN CELULARES ANTIGUOS ===== -->
  <app-pop-up-modal-custom
    [show]="showDeviceWarningModal"
    titulo="Recomendación para celulares antiguos"
    [mensaje]="mensajeDispositivoWarning"
    tipo="warning"
    textoBoton="Entendido"
    (confirmado)="showDeviceWarningModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL TAMAÑO DE ARCHIVO ===== -->
  <app-pop-up-modal-custom
    [show]="showFileSizeError"
    titulo="Archivo demasiado grande"
    mensaje="El archivo excede el tamaño máximo permitido de 50 MB."
    tipo="warning"
    (confirmado)="showFileSizeError = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL ARCHIVO DUPLICADO ===== -->
  <app-pop-up-modal-custom
    [show]="showArchivoDuplicadoModal"
    titulo="Archivo duplicado"
    [mensaje]="mensajeArchivoDuplicado"
    tipo="warning"
    (confirmado)="showArchivoDuplicadoModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL SUBIDA FALLIDA (reintentar / cambiar archivo desde la modal) ===== -->
  <app-pop-up-modal-custom
    [show]="showSubidaFallidaModal"
    titulo="No se pudieron subir los documentos"
    [mensaje]="conReferencia('Estos documentos no se subieron correctamente. Elegí el archivo nuevamente o reintentá la subida.')"
    tipo="error"
    textoBoton="Reintentar subida"
    textoBotonCancelar="Cancelar"
    (confirmado)="reintentarSubidasFallidas()"
    (cerrado)="showSubidaFallidaModal = false"
  >
    <div class="subida-fallida-lista">
      <div class="subida-fallida-item" *ngFor="let f of subidasFallidas">
        <div class="subida-fallida-item__info">
          <strong class="subida-fallida-item__label">{{ f.label }}</strong>
          <span class="subida-fallida-item__nombre">Archivo actual: {{ f.archivo }}</span>
        </div>
        <label class="subida-fallida-item__picker">
          <input #retryFile hidden type="file"
            accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,image/heic,image/heif"
            (change)="onSlotFileSelected(f.slotIndex, f.tipo, $event)">
          <button type="button" class="btn-slot" (click)="retryFile.click()">Elegir otro archivo</button>
        </label>
      </div>
      <p class="subida-fallida-ayuda">Verificá que el archivo sea PDF, JPG, PNG o HEIC y de hasta 50 MB.</p>
    </div>
  </app-pop-up-modal-custom>

  <!-- ===== MODAL ERROR DE REGISTRO ===== -->
  <app-pop-up-modal-custom
    [show]="showRegistroErrorModal"
    titulo="No se pudo completar la inscripción"
    [mensaje]="conReferencia('Ocurrió un error inesperado durante el registro. Por favor, intentá nuevamente.')"
    tipo="error"
    (confirmado)="showRegistroErrorModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== MODAL CONFIRMACIÓN AFILIACIÓN ===== -->
  <app-pop-up-modal-custom
    [show]="showConfirmarAfiliacionModal"
    titulo="Confirmación de afiliación"
    mensaje="Al continuar, usted comenzará el proceso de afiliación a la obra social."
    tipo="info"
    textoBoton="Continuar"
    textoBotonCancelar="Cancelar"
    (confirmado)="procesarInscripcion()"
    (cerrado)="showConfirmarAfiliacionModal = false"
  ></app-pop-up-modal-custom>

  <!-- ===== BARRA DE PROGRESO DE INSCRIPCIÓN ===== -->
  <app-spinner
      [show]="isUploadingFile"
      variant="bar"
      [progress]="progresoSubida"
      [progressText]="textoProgreso"
      [hint]="avisoSubida"
      [type]="'fullscreen'"
      [size]="'large'"
      [color]="'#4CA7C8'"
      [trackColor]="'#DCEFF5'"
      [blurBackground]="true">
  </app-spinner>
</div>

<!-- ================================================================ -->
<!-- FASE DDJJ (merged) -->
<!-- ================================================================ -->
<div class="ddjj-bg" *ngIf="phase === 'ddjj'">
    <div class="ddjj-container">

        <!-- AUDITORIA-STYLE HEADER -->
        <div class="inscripcion-header">
            <div class="inscripcion-header__accent"></div>
            <div class="container inscripcion-header__inner">
                <span class="material-icons inscripcion-header__icon">fact_check</span>
                <div>
                    <h1 class="inscripcion-header__title">Declaración Jurada · <span>O.S.O.E.T.S.Y.L.R.A.</span></h1>
                    <p class="inscripcion-header__subtitle">Declaración de salud — Código O.S. 1-2740-6</p>
                </div>
            </div>
        </div>

        <!-- ===== AVISO PRIMER PASO COMPLETADO ===== -->
        <div class="ddjj-aviso-paso1" *ngIf="avisoPaso1Completado">
            <div class="ddjj-aviso-paso1__icono"><i class="fas fa-check-circle"></i></div>
            <div class="ddjj-aviso-paso1__texto">
                <strong>Primer paso completado</strong>
                <span>Ha completado exitosamente el primer paso de su inscripción. Para finalizar el proceso de afiliación es obligatorio completar la Declaración Jurada a continuación. Su solicitud no será válida hasta que todos los pasos requeridos sean finalizados.</span>
            </div>
            <button type="button" class="ddjj-aviso-paso1__cerrar" (click)="cerrarAvisoPaso1()" aria-label="Cerrar aviso">×</button>
        </div>

        <div class="ddjj-form-container">
            <form [formGroup]="declaracionForm" (ngSubmit)="onSubmitDdjj()">

                <!-- STEP BAR -->
                <div class="step-bar">
                    <ng-container *ngFor="let step of ddjjSteps; let i = index">
                        <div class="step" [class.active]="ddjjStep === i + 1" [class.completed]="ddjjMaxStep > i + 1" [class.error-step]="ddjjStepErrors[i]" (click)="irAPasoDdjj(i + 1)">
                            <div class="step-circle">
                                <i *ngIf="ddjjMaxStep > i + 1 && !ddjjStepErrors[i]" class="fas fa-check"></i>
                                <span *ngIf="ddjjMaxStep <= i + 1 || ddjjStepErrors[i]">{{ i + 1 }}</span>
                            </div>
                            <span class="step-label">{{ step }}</span>
                        </div>
                    </ng-container>
                </div>

                <!-- PASO 1: DATOS PERSONALES -->
                <div *ngIf="ddjjStep === 1" class="step-content">
                    <div class="step-title">Datos personales</div>
                    <div formGroupName="datosPersonales">
                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="nombre" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.nombre")
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Apellido</mat-label>
                                <input matInput formControlName="apellido" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.apellido")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Fecha de Nacimiento</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="pickerNacimiento"
                                    formControlName="fechaNacimiento"
                                    readonly
                                    (click)="pickerNacimiento.open()"
                                />
                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="pickerNacimiento"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #pickerNacimiento></mat-datepicker>
                                <mat-error>{{
                                    getErrorMessage(
                                        "datosPersonales.fechaNacimiento"
                                    )
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>DNI</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="dni"
                                />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.dni")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field
                                appearance="outline"
                                class="form-group full-width"
                            >
                                <mat-label>Domicilio</mat-label>
                                <input matInput formControlName="domicilio" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.domicilio")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Localidad</mat-label>
                                <input matInput formControlName="localidad" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.localidad")
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Teléfono</mat-label>
                                <input
                                    matInput
                                    type="tel"
                                    formControlName="telefono"
                                />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.telefono")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row" *ngIf="!esMonotributo">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Empleador</mat-label>
                                <input matInput formControlName="empleador" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.empleador")
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>CUIT</mat-label>
                                <input matInput formControlName="cuit" />
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.cuit")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Grupo Sanguíneo</mat-label>
                                <mat-select formControlName="grupoSanguineo">
                                    <mat-option value="A">A</mat-option>
                                    <mat-option value="B">B</mat-option>
                                    <mat-option value="AB">AB</mat-option>
                                    <mat-option value="O">O</mat-option>
                                </mat-select>
                                <mat-error>{{
                                    getErrorMessage(
                                        "datosPersonales.grupoSanguineo"
                                    )
                                }}</mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label>Factor RH</mat-label>
                                <mat-select formControlName="factorRh">
                                    <mat-option [value]="true"
                                        >Positivo (+)</mat-option
                                    >
                                    <mat-option [value]="false"
                                        >Negativo (-)</mat-option
                                    >
                                </mat-select>
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.factorRh")
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field
                                appearance="outline"
                                class="form-group full-width"
                            >
                                <mat-label>Otros</mat-label>
                                <textarea
                                    matInput
                                    rows="3"
                                    formControlName="otros"
                                ></textarea>
                                <mat-error>{{
                                    getErrorMessage("datosPersonales.otros")
                                }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 2: ANTECEDENTES MÉDICOS -->
                <div *ngIf="ddjjStep === 2" class="step-content">
                    <div class="step-title">Antecedentes médicos</div>
                    <div formGroupName="antecedentesMedicos">
                        <div formGroupName="atencionMedica">
                            <div class="form-row">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group"
                                >
                                    <mat-label
                                        >¿Está bajo atención médica?</mat-label
                                    >
                                    <mat-select formControlName="bajoAtencion">
                                        <mat-option [value]="true">Sí</mat-option>
                                        <mat-option [value]="false">No</mat-option>
                                    </mat-select>
                                    <mat-error>{{
                                        getErrorMessage(
                                            "antecedentesMedicos.atencionMedica.bajoAtencion"
                                        )
                                    }}</mat-error>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Por quién?</mat-label>
                                    <input
                                        matInput
                                        formControlName="medicoAtiende"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "antecedentesMedicos.atencionMedica.medicoAtiende"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="form-row">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Por qué enfermedad?</mat-label>
                                    <input matInput formControlName="enfermedad" />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "antecedentesMedicos.atencionMedica.enfermedad"
                                        )
                                    }}</mat-error>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Cuál?</mat-label>
                                    <input
                                        matInput
                                        formControlName="cualEnfermedad"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "antecedentesMedicos.atencionMedica.cualEnfermedad"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="form-row">
                            <mat-form-field
                                appearance="outline"
                                class="form-group full-width"
                            >
                                <mat-label
                                    >¿Qué medicamentos ha tomado en los últimos 6
                                    meses?</mat-label
                                >
                                <textarea
                                    matInput
                                    rows="3"
                                    formControlName="medicamentosUltimos6Meses"
                                ></textarea>
                                <mat-error>{{
                                    getErrorMessage(
                                        "antecedentesMedicos.medicamentosUltimos6Meses"
                                    )
                                }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-group">
                                <mat-label
                                    >¿En este momento tiene algún motivo para
                                    consultar a algún médico?</mat-label
                                >
                                <mat-select formControlName="motivoConsultaActual">
                                    <mat-option [value]="true">Sí</mat-option>
                                    <mat-option [value]="false">No</mat-option>
                                </mat-select>
                                <mat-error>{{
                                    getErrorMessage(
                                        "antecedentesMedicos.motivoConsultaActual"
                                    )
                                }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 3: HÁBITOS FISIOLÓGICOS -->
                <div *ngIf="ddjjStep === 3" class="step-content">
                    <div class="step-title">Hábitos fisiológicos</div>
                    <div formGroupName="habitosFisiologicos">
                        <div class="radio-columns-container">
                            <div
                                class="radio-card"
                                formGroupName="alimentacion"
                            >
                                <div class="form-group">
                                    <label
                                        >¿Se alimenta con 4/5 comidas
                                        diarias?</label
                                    >
                                    <mat-radio-group
                                        formControlName="comidasDiarias"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "habitosFisiologicos.alimentacion.comidasDiarias"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label
                                            >¿Con qué se alimenta
                                            mayoritariamente?</mat-label
                                        >
                                        <input
                                            matInput
                                            formControlName="queAlimentacion"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "habitosFisiologicos.alimentacion.queAlimentacion"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="alimentacion"
                            >
                                <div class="form-group">
                                    <label>¿Incluye desayuno?</label>
                                    <mat-radio-group
                                        formControlName="incluyeDesayuno"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "habitosFisiologicos.alimentacion.incluyeDesayuno"
                                        )
                                    }}</mat-error>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="sueno">
                                <div class="form-group">
                                    <label>¿Tiene sueño tranquilo?</label>
                                    <mat-radio-group
                                        formControlName="suenoTranquilo"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "habitosFisiologicos.sueno.suenoTranquilo"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group"
                                    >
                                        <mat-label>Horas de sueño</mat-label>
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="horasSueno"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "habitosFisiologicos.sueno.horasSueno"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card">
                                <div class="form-group">
                                    <label>¿Tiene constipación?</label>
                                    <mat-radio-group
                                        formControlName="constipacion"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "habitosFisiologicos.constipacion"
                                        )
                                    }}</mat-error>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="deporte">
                                <div class="form-group">
                                    <label>¿Realiza algún deporte?</label>
                                    <mat-radio-group
                                        formControlName="realizaDeporte"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "habitosFisiologicos.deporte.realizaDeporte"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cualDeporte"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "habitosFisiologicos.deporte.cualDeporte"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 4: HÁBITOS TÓXICOS -->
                <div *ngIf="ddjjStep === 4" class="step-content">
                    <div class="step-title">Hábitos tóxicos</div>
                    <div
                        class="radio-columns-container"
                        formGroupName="habitosToxicos"
                    >
                        <div class="radio-card" formGroupName="fumador">
                            <div class="form-group">
                                <label>¿Fuma?</label>
                                <mat-radio-group
                                    formControlName="fuma"
                                    class="radio-group"
                                >
                                    <mat-radio-button [value]="true"
                                        >Sí</mat-radio-button
                                    >
                                    <mat-radio-button [value]="false"
                                        >No</mat-radio-button
                                    >
                                </mat-radio-group>
                                <mat-error class="radio-error">{{
                                    getErrorMessage(
                                        "habitosToxicos.fumador.fuma"
                                    )
                                }}</mat-error>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Desde cuándo?</mat-label>
                                    <input
                                        matInput
                                        formControlName="desdeCuando"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.fumador.desdeCuando"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>Cantidad por día</mat-label>
                                    <input
                                        matInput
                                        formControlName="cantidadPorDia"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.fumador.cantidadPorDia"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="radio-card" formGroupName="alcohol">
                            <div class="form-group">
                                <label>¿Toma bebidas alcohólicas?</label>
                                <mat-radio-group
                                    formControlName="tomaAlcohol"
                                    class="radio-group"
                                >
                                    <mat-radio-button [value]="true"
                                        >Sí</mat-radio-button
                                    >
                                    <mat-radio-button [value]="false"
                                        >No</mat-radio-button
                                    >
                                </mat-radio-group>
                                <mat-error class="radio-error">{{
                                    getErrorMessage(
                                        "habitosToxicos.alcohol.tomaAlcohol"
                                    )
                                }}</mat-error>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Cuáles?</mat-label>
                                    <input matInput formControlName="cuales" />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.alcohol.cuales"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Cuándo?</mat-label>
                                    <input matInput formControlName="cuando" />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.alcohol.cuando"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Cuánto?</mat-label>
                                    <input matInput formControlName="cuanto" />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.alcohol.cuanto"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="radio-card" formGroupName="drogas">
                            <div class="form-group">
                                <label>¿Consume drogas?</label>
                                <mat-radio-group
                                    formControlName="consumeDrogas"
                                    class="radio-group"
                                >
                                    <mat-radio-button [value]="true"
                                        >Sí</mat-radio-button
                                    >
                                    <mat-radio-button [value]="false"
                                        >No</mat-radio-button
                                    >
                                </mat-radio-group>
                                <mat-error class="radio-error">{{
                                    getErrorMessage(
                                        "habitosToxicos.drogas.consumeDrogas"
                                    )
                                }}</mat-error>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>¿Cuáles?</mat-label>
                                    <input matInput formControlName="cuales" />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.drogas.cuales"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="radio-card" formGroupName="automedicacion">
                            <div class="form-group">
                                <label>¿Se automedica?</label>
                                <mat-radio-group
                                    formControlName="seAutomedica"
                                    class="radio-group"
                                >
                                    <mat-radio-button [value]="true"
                                        >Sí</mat-radio-button
                                    >
                                    <mat-radio-button [value]="false"
                                        >No</mat-radio-button
                                    >
                                </mat-radio-group>
                                <mat-error class="radio-error">{{
                                    getErrorMessage(
                                        "habitosToxicos.automedicacion.seAutomedica"
                                    )
                                }}</mat-error>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>Medicación</mat-label>
                                    <input
                                        matInput
                                        formControlName="medicacion"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.automedicacion.medicacion"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="mat-form-field-blanco">
                                <mat-form-field
                                    appearance="outline"
                                    class="form-group full-width"
                                >
                                    <mat-label>Frecuencia</mat-label>
                                    <input
                                        matInput
                                        formControlName="frecuencia"
                                    />
                                    <mat-error>{{
                                        getErrorMessage(
                                            "habitosToxicos.automedicacion.frecuencia"
                                        )
                                    }}</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 5: GINECO-OBSTÉTRICOS -->
                <div *ngIf="ddjjStep === 5" class="step-content">
                    <div class="step-title">Antecedentes Gineco-Obstétricos</div>
                    <div formGroupName="antecedentesGinecoObstetricos">
                        <div class="radio-columns-container">
                            <div
                                class="radio-card"
                                formGroupName="alteracionesMenstruales"
                            >
                                <div class="form-group">
                                    <label
                                        >¿Tiene alteraciones menstruales?</label
                                    >
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesGinecoObstetricos.alteracionesMenstruales.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label
                                            >Edad en que menstruó por primera
                                            vez</mat-label
                                        >
                                        <input
                                            matInput
                                            formControlName="primeraMenstruacionEdad"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.alteracionesMenstruales.primeraMenstruacionEdad"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label
                                            >Fecha de última
                                            menstruación</mat-label
                                        >
                                        <input
                                            matInput
                                            formControlName="ultimaMenstruacionFecha"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.alteracionesMenstruales.ultimaMenstruacionFecha"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="embarazos">
                                <div class="form-group">
                                    <label>¿Embarazos?</label>
                                    <mat-radio-group
                                        formControlName="tuvo"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesGinecoObstetricos.embarazos.tuvo"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuántos?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cantidad"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.embarazos.cantidad"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>Parto Normal</mat-label>
                                        <input
                                            matInput
                                            formControlName="partoNormal"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.embarazos.partoNormal"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>Cesáreas</mat-label>
                                        <input
                                            matInput
                                            formControlName="cesareas"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.embarazos.cesareas"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>Abortos</mat-label>
                                        <input
                                            matInput
                                            formControlName="abortos"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.embarazos.abortos"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="patologiaMamaria"
                            >
                                <div class="form-group">
                                    <label>¿Tiene una patología mamaria?</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesGinecoObstetricos.patologiaMamaria.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesGinecoObstetricos.patologiaMamaria.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 6: FAMILIARES -->
                <div *ngIf="ddjjStep === 6" class="step-content">
                    <div class="step-title">Antecedentes Familiares</div>
                    <div class="step-subtitle">
                        ¿Tiene o han tenido sus parientes (considerar madre,
                        padre, hermanos, cónyuges e hijos) algunas de las
                        enfermedades que se nombran a continuación?
                    </div>
                    <div formGroupName="antecedentesFamiliares">
                        <div class="radio-columns-container">
                            <div
                                class="radio-card"
                                formGroupName="artritisFamiliar"
                            >
                                <div class="form-group">
                                    <label>Artritis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.artritisFamiliar.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.artritisFamiliar.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.artritisFamiliar.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadesInmunologicas"
                            >
                                <div class="form-group">
                                    <label>Enfermedades Inmunológicas</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.enfermedadesInmunologicas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesInmunologicas.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesInmunologicas.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="cancer">
                                <div class="form-group">
                                    <label>Cáncer</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.cancer.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.cancer.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.cancer.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadCardiaca"
                            >
                                <div class="form-group">
                                    <label>Enfermedad Cardíaca</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.enfermedadCardiaca.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadCardiaca.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadCardiaca.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="tensionAlta">
                                <div class="form-group">
                                    <label>Tensión Alta</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.tensionAlta.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.tensionAlta.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.tensionAlta.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadRenal"
                            >
                                <div class="form-group">
                                    <label>Enfermedad Renal (Urinarias)</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.enfermedadRenal.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadRenal.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadRenal.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="tuberculosis"
                            >
                                <div class="form-group">
                                    <label>Tuberculosis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.tuberculosis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.tuberculosis.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.tuberculosis.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadesMentales"
                            >
                                <div class="form-group">
                                    <label>Enfermedades Mentales</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.enfermedadesMentales.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesMentales.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesMentales.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadesHereditariasGeneticas"
                            >
                                <div class="form-group">
                                    <label
                                        >Enfermedades Hereditarias /
                                        Genéticas</label
                                    >
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesFamiliares.enfermedadesHereditariasGeneticas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cuales"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesHereditariasGeneticas.cuales"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Quién?</mat-label>
                                        <input
                                            matInput
                                            formControlName="quien"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesFamiliares.enfermedadesHereditariasGeneticas.quien"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 7: PATOLÓGICOS -->
                <div *ngIf="ddjjStep === 7" class="step-content">
                    <div class="step-title">Antecedentes Patológicos</div>
                    <div class="step-subtitle">
                        ¿Tiene o ha tenido alguna de las enfermedades que se
                        nombran a continuación?
                    </div>
                    <div formGroupName="antecedentesPatologicos">
                        <div class="radio-columns-container">
                            <div class="radio-card" formGroupName="diabetes">
                                <div class="form-group">
                                    <label>Diabetes</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.diabetes.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.diabetes.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="hipertension"
                            >
                                <div class="form-group">
                                    <label>Hipertensión</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.hipertension.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.hipertension.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadCardiaca"
                            >
                                <div class="form-group">
                                    <label>Enfermedad Cardíaca</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.enfermedadCardiaca.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.enfermedadCardiaca.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="alergia">
                                <div class="form-group">
                                    <label>Alergia</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.alergia.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.alergia.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="asma">
                                <div class="form-group">
                                    <label>Asma</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.asma.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.asma.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="tuberculosis"
                            >
                                <div class="form-group">
                                    <label>Tuberculosis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.tuberculosis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.tuberculosis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="calculosRenales"
                            >
                                <div class="form-group">
                                    <label>Cálculos Renales</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.calculosRenales.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.calculosRenales.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="infeccionUrinaria"
                            >
                                <div class="form-group">
                                    <label>Infección Urinaria</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.infeccionUrinaria.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.infeccionUrinaria.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="hepatitis">
                                <div class="form-group">
                                    <label>Hepatitis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.hepatitis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.hepatitis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="chagas">
                                <div class="form-group">
                                    <label>Chagas</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.chagas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.chagas.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="brucelosis">
                                <div class="form-group">
                                    <label>Brucelosis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.brucelosis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.brucelosis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="toxoplasmosis"
                            >
                                <div class="form-group">
                                    <label>Toxoplasmosis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.toxoplasmosis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.toxoplasmosis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="trastornosPsiquiatricos"
                            >
                                <div class="form-group">
                                    <label>Trastornos Psiquiátricos</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.trastornosPsiquiatricos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.trastornosPsiquiatricos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="trastornosMarcha"
                            >
                                <div class="form-group">
                                    <label>Trastornos de la marcha</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.trastornosMarcha.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.trastornosMarcha.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="dispositivosMedicos"
                            >
                                <div class="form-group">
                                    <label
                                        >¿Tiene colocado algún dispositivo
                                        médico (implante, prótesis,
                                        etc.)?</label
                                    >
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.dispositivosMedicos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.dispositivosMedicos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadesTransmisionSexual"
                            >
                                <div class="form-group">
                                    <label
                                        >Enfermedades de Transmisión
                                        Sexual</label
                                    >
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.enfermedadesTransmisionSexual.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.enfermedadesTransmisionSexual.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="alteracionesEndocrinas"
                            >
                                <div class="form-group">
                                    <label>Alteraciones Endócrinas</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.alteracionesEndocrinas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.alteracionesEndocrinas.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="artritis">
                                <div class="form-group">
                                    <label>Artritis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.artritis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.artritis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="enfermedadesPiel"
                            >
                                <div class="form-group">
                                    <label>Enfermedades de la Piel</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.enfermedadesPiel.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.enfermedadesPiel.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="epilepsia">
                                <div class="form-group">
                                    <label>Epilepsia</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.epilepsia.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.epilepsia.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="ulceraGastrica"
                            >
                                <div class="form-group">
                                    <label>Úlcera gástrica</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.ulceraGastrica.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.ulceraGastrica.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="gastritis">
                                <div class="form-group">
                                    <label>Gastritis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.gastritis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.gastritis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="hemorroides">
                                <div class="form-group">
                                    <label>Hemorroides</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.hemorroides.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.hemorroides.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="hernias">
                                <div class="form-group">
                                    <label>Hernias</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.hernias.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.hernias.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="sinusitis">
                                <div class="form-group">
                                    <label>Sinusitis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.sinusitis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.sinusitis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="cancerTumores"
                            >
                                <div class="form-group">
                                    <label>Cáncer o tumores</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.cancerTumores.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.cancerTumores.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="varices">
                                <div class="form-group">
                                    <label>Várices</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.varices.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuáles?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.varices.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="discapacidad"
                            >
                                <div class="form-group">
                                    <label>Discapacidad</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.discapacidad.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.discapacidad.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="incapacidad">
                                <div class="form-group">
                                    <label>Incapacidad</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.incapacidad.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.incapacidad.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="medicoEspecialTraslado"
                            >
                                <div class="form-group">
                                    <label
                                        >¿Requiere algún médico especial para
                                        trasladarse?</label
                                    >
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "antecedentesPatologicos.medicoEspecialTraslado.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "antecedentesPatologicos.medicoEspecialTraslado.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 8: SÍNTOMAS -->
                <div *ngIf="ddjjStep === 8" class="step-content">
                    <div class="step-title">¿Tiene o ha tenido alguna vez?</div>
                    <div formGroupName="sintomasYExperiencias">
                        <div class="radio-columns-container">
                            <div
                                class="radio-card"
                                formGroupName="mareosDesmayos"
                            >
                                <div class="form-group">
                                    <label>Mareos o desmayos</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.mareosDesmayos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.mareosDesmayos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="convulsiones"
                            >
                                <div class="form-group">
                                    <label>Convulsiones</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.convulsiones.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.convulsiones.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="doloresCabeza"
                            >
                                <div class="form-group">
                                    <label>Dolores de Cabeza</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.doloresCabeza.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.doloresCabeza.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="neuralgiaNeuritis"
                            >
                                <div class="form-group">
                                    <label>Neuralgia o neuritis</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.neuralgiaNeuritis.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.neuralgiaNeuritis.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="depresion">
                                <div class="form-group">
                                    <label>Depresión</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.depresion.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.depresion.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="trastornosOculares"
                            >
                                <div class="form-group">
                                    <label>Trastornos Oculares</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.trastornosOculares.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.trastornosOculares.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="supuracionOidos"
                            >
                                <div class="form-group">
                                    <label>Supuración de Oídos</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.supuracionOidos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.supuracionOidos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="resfriosFrecuentes"
                            >
                                <div class="form-group">
                                    <label>Resfríos frecuentes</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.resfriosFrecuentes.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.resfriosFrecuentes.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="tosCronica">
                                <div class="form-group">
                                    <label>Tos Crónica</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.tosCronica.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.tosCronica.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="sudoresNocturnos"
                            >
                                <div class="form-group">
                                    <label>Sudores Nocturnos</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.sudoresNocturnos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.sudoresNocturnos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="perdidaPeso">
                                <div class="form-group">
                                    <label>Pérdida de peso</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.perdidaPeso.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.perdidaPeso.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="doloresPecho"
                            >
                                <div class="form-group">
                                    <label>Dolores en el pecho</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.doloresPecho.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.doloresPecho.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="temblores">
                                <div class="form-group">
                                    <label>Temblores</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.temblores.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.temblores.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="debilidadMuscular"
                            >
                                <div class="form-group">
                                    <label>Debilidad muscular</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.debilidadMuscular.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.debilidadMuscular.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="faltaAire">
                                <div class="form-group">
                                    <label>Falta de aire</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.faltaAire.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.faltaAire.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="palpitaciones"
                            >
                                <div class="form-group">
                                    <label>Palpitaciones</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.palpitaciones.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.palpitaciones.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="acidez">
                                <div class="form-group">
                                    <label>Acidez</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.acidez.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.acidez.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="dificultadOrinar"
                            >
                                <div class="form-group">
                                    <label>Dificultad para orinar</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.dificultadOrinar.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.dificultadOrinar.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="sangreOrina">
                                <div class="form-group">
                                    <label>Sangre en orina</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.sangreOrina.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.sangreOrina.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="articulacionesHinchadas"
                            >
                                <div class="form-group">
                                    <label>Articulaciones hinchadas</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.articulacionesHinchadas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.articulacionesHinchadas.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="lumbalgia">
                                <div class="form-group">
                                    <label>Lumbalgia</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.lumbalgia.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.lumbalgia.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="ciatalgia">
                                <div class="form-group">
                                    <label>Ciatalgia</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.ciatalgia.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.ciatalgia.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="desviacionColumna"
                            >
                                <div class="form-group">
                                    <label>Desviación columna</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.desviacionColumna.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.desviacionColumna.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="fracturas">
                                <div class="form-group">
                                    <label>Fracturas</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.fracturas.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.fracturas.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="traumatismos"
                            >
                                <div class="form-group">
                                    <label>Traumatismos</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.traumatismos.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.traumatismos.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="cirugias">
                                <div class="form-group">
                                    <label>Cirugías</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.cirugias.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.cirugias.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div
                                class="radio-card"
                                formGroupName="internaciones"
                            >
                                <div class="form-group">
                                    <label>Internaciones</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.internaciones.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.internaciones.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="otros">
                                <div class="form-group">
                                    <label>Otra</label>
                                    <mat-radio-group
                                        formControlName="tiene"
                                        class="radio-group"
                                    >
                                        <mat-radio-button [value]="true"
                                            >Sí</mat-radio-button
                                        >
                                        <mat-radio-button [value]="false"
                                            >No</mat-radio-button
                                        >
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage(
                                            "sintomasYExperiencias.otros.tiene"
                                        )
                                    }}</mat-error>
                                </div>

                                <div class="mat-form-field-blanco">
                                    <mat-form-field
                                        appearance="outline"
                                        class="form-group full-width"
                                    >
                                        <mat-label>¿Cuál?</mat-label>
                                        <input
                                            matInput
                                            formControlName="cual"
                                        />
                                        <mat-error>{{
                                            getErrorMessage(
                                                "sintomasYExperiencias.otros.cual"
                                            )
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 9: QUIRÚRGICOS -->
                <div *ngIf="ddjjStep === 9" class="step-content">
                    <div class="step-title">Antecedentes Quirúrgicos</div>
                    <div class="step-subtitle">
                        ¿Ha tenido alguna de las siguientes cirugías?
                    </div>
                    <div formGroupName="antecedentesQuirurgicos">
                        <div class="radio-columns-container">
                            <div class="radio-card" formGroupName="traumatologica">
                                <div class="form-group">
                                    <label>Cirugía Traumatológica</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.traumatologica.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.traumatologica.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="cardiaca">
                                <div class="form-group">
                                    <label>Cirugía Cardíaca</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.cardiaca.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.cardiaca.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="ginecologica">
                                <div class="form-group">
                                    <label>Cirugía Ginecológica</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.ginecologica.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.ginecologica.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="general">
                                <div class="form-group">
                                    <label>Cirugía General</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.general.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.general.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="neuroquirurgicas">
                                <div class="form-group">
                                    <label>Neuroquirúrgicas</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.neuroquirurgicas.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.neuroquirurgicas.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="malformacionesNacimiento">
                                <div class="form-group">
                                    <label>Cirugías por malformaciones de Nacimiento<br><small>(Espina bífida, teratomas, etc)</small></label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.malformacionesNacimiento.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.malformacionesNacimiento.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="hidrocefalia">
                                <div class="form-group">
                                    <label>Hidrocefalia</label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.hidrocefalia.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.hidrocefalia.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="radio-card" formGroupName="malformacionesGeneticas">
                                <div class="form-group">
                                    <label>Cirugías por malformaciones genéticas de nacimiento<br><small>(Síndrome de Down, Turner, etc)</small></label>
                                    <mat-radio-group formControlName="tiene" class="radio-group">
                                        <mat-radio-button [value]="true">Sí</mat-radio-button>
                                        <mat-radio-button [value]="false">No</mat-radio-button>
                                    </mat-radio-group>
                                    <mat-error class="radio-error">{{
                                        getErrorMessage("antecedentesQuirurgicos.malformacionesGeneticas.tiene")
                                    }}</mat-error>
                                </div>
                                <div class="mat-form-field-blanco">
                                    <mat-form-field appearance="outline" class="form-group full-width">
                                        <mat-label>¿Cuál?</mat-label>
                                        <input matInput formControlName="cual" />
                                        <mat-error>{{
                                            getErrorMessage("antecedentesQuirurgicos.malformacionesGeneticas.cual")
                                        }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="button" class="btn-next" (click)="nextStepDdjj()">Siguiente</button>
                    </div>
                </div>

                <!-- PASO 10: REVISIÓN Y ENVÍO -->
                <div *ngIf="ddjjStep === 10" class="step-content">
                    <div class="step-title">Revisión y envío</div>

                    <div class="review-section">
                        <p>
                            La aceptación de toda solicitud de afiliación queda
                            supeditada a su aprobación por parte de OSOETSYLRA, la
                            cual podra observarla o rechazarla a su exclusivo
                            criterio. Los interesados en ingresar deberán efectuar
                            esta DECLARACIÓN JURADA DE SALUD sin cuya previa
                            consideración no se decidirá la admisión respectiva. La
                            falsedad y omisión de alguna enfermedad preexistente en
                            esta Declaración Jurada eximirá a OSOETSYLRA del
                            reconocimiento de los gastos que ocasione su
                            tratamiento, sin perjuicio de la reparación - por parte
                            del titular - de los gastos que hubiera ocasionado.
                        </p>
                        <p>
                            Declaro bajo juramento que los datos e información
                            precedentes son totalmente exactos y veraces
                            sometiéndome a su verificación y haciéndome responsable
                            detoda informalidad que pudiera dar lugar a
                            transgresiones al Régimen Legal (Art. Nº 293 del CODIGO
                            PENAL) y reglamentación específica de OSOETSYLRA las
                            quedeclaro conocer.
                        </p>
                    </div>

                    <div class="step-actions">
                        <button type="button" class="btn-prev" (click)="prevStepDdjj()">Anterior</button>
                        <button type="submit" class="btn-next" [disabled]="isUploadingDDJJ">Enviar Declaración</button>
                    </div>
                </div>

            </form>

            <div class="contact-info">
                <small>
                    <a href="https://maps.app.goo.gl/LyBuWxd1pVH1mDHN9" target="_blank" rel="noopener">Culpina 25/31</a> • C1406ENA • Ciudad Autónoma de Buenos Aires • República Argentina
                    <br>
                    Tel/Fax: 4612-2000 Líneas Rotativas • <a href="https://www.osoetsylra.org" target="_blank" rel="noopener">www.osoetsylra.org</a>
                </small>
            </div>

        </div>
    </div>

    <!-- Barra de progreso DDJJ (indeterminada: sin progreso medible) -->
    <app-spinner
        [show]="isUploadingDDJJ"
        variant="bar"
        [progressText]="'Enviando su declaración jurada, por favor espere'"
        [type]="'fullscreen'"
        [size]="'large'"
        [color]="'#4CA7C8'"
        [trackColor]="'#DCEFF5'"
        [blurBackground]="true">
    </app-spinner>

    <!-- Modal confirmación DDJJ -->
    <app-pop-up-modal-custom
      [show]="showConfirmarDdjjModal"
      titulo="Confirmación de Declaración Jurada"
      mensaje="Al enviar esta declaración jurada, usted confirma bajo juramento la veracidad de la información proporcionada."
      tipo="warning"
      textoBoton="Confirmar y Enviar"
      textoBotonCancelar="Cancelar"
      (confirmado)="procesarDdjj()"
      (cerrado)="showConfirmarDdjjModal = false"
    ></app-pop-up-modal-custom>

    <!-- Modal error DDJJ (nunca fallar en silencio) -->
    <app-pop-up-modal-custom
      [show]="showDdjjErrorModal"
      titulo="No se pudo enviar la declaración"
      [mensaje]="ddjjErrorMensaje"
      tipo="error"
      (confirmado)="showDdjjErrorModal = false"
    ></app-pop-up-modal-custom>

    <!-- Modal éxito DDJJ -->
    <app-pop-up-modal-custom
      [show]="showDdjjExitosaModal"
      titulo="Declaración Jurada enviada"
      mensaje="Su declaración jurada ha sido enviada exitosamente. Su afiliación está siendo procesada."
      tipo="info"
      (confirmado)="irAHome()"
    ></app-pop-up-modal-custom>
</div>

